import auth0 from 'auth0-js';

export function initAuth0(config) {
  if (typeof auth0 !== 'object') {
    throw new Error('Auth0 SDK not loaded');
  }

  const webAuth = new auth0.WebAuth({
    domain: config.domain,
    clientID: config.clientId,
    redirectUri: config.redirectUri,
    audience: config.audience,
    responseType: config.responseType,
  });

  function displayError(err) {
    const errorMessage = document.getElementById('error-message');
    if (errorMessage) {
      errorMessage.innerText = err.policy || err.description || 'Something went wrong';
      errorMessage.style.display = 'block';
    }
  }

  async function sendCode() {
    const csrfInput = document.querySelector('input[name="_token"]');
    const response = await fetch(config.passwordlessStartUrl, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-CSRF-TOKEN': csrfInput?.value || '',
      },
    });
    const result = await response.json().catch(() => ({}));

    if (!response.ok) {
      const error = new Error(result.description || 'Something went wrong');
      error.description = error.message;
      throw error;
    }

    return result;
  }

  function verifyCode(email, code) {
    return new Promise((resolve, reject) => {
      const verifyBtn = document.getElementById('verify-code');
      const originalText = verifyBtn?.innerText || 'Verify';

      if (verifyBtn) {
        verifyBtn.disabled = true;
        verifyBtn.innerText = 'Verifying...';
      }

      webAuth.passwordlessLogin(
        {
          connection: 'email',
          email: email,
          verificationCode: code,
        },
        function (err, res) {
          if (verifyBtn) {
            verifyBtn.disabled = false;
            verifyBtn.innerText = originalText;
          }

          if (err) {
            displayError(err);
            return reject(err);
          } else {
            resolve(res);
          }
        },
      );
    });
  }

  function loginWithSocial(method, courseKey = '') {
    webAuth.authorize(
      {
        connection: method,
        state: JSON.stringify({ course_key: courseKey }),
      },
      function (err) {
        if (err) displayError(err);
      },
    );
  }

  return {
    sendCode,
    verifyCode,
    loginWithSocial,
    webAuth,
    displayError,
  };
}
